import React from "react";
import { Link, Switch, Route, Redirect, useLocation } from "react-router-dom";
import "../../../_metronic/_assets/sass/pages/login/login-1.scss";
import logo from "../../assets/logo/logo__login.svg";
import Login from "./Login/LoginPage";
import RecoveryPassword from "./RecoveryPassword/RecoveryPasswordPage";
import Password from "./Password";
import PassActions from "./Password/enum/Actions";
import Content from "../home/components/Content/Content";
import globalColors from "../../../_metronic/_assets/sass/custom/globalColors.scss";
import ActivateAccount from "./ActivateAccount";
import FinishRegistration from "./FinishRegistration";
import { FiMoon, FiSun } from "react-icons/fi";
import { isXavierThemeV2Enabled } from "../../utils/FeatureFlags";
import { useXavierTheme } from "../../design-system/theme/XavierThemeProvider";
import XavierWordmark from "../../design-system/components/XavierWordmark/XavierWordmark";
import "./XavierAuth.css";

export default function AuthPage() {
  const location = useLocation();
  const { mode, toggleMode } = useXavierTheme();
  const isFinishRegistration = location.pathname === "/auth/finalizar-cadastro";
  const routes = (
    <Switch>
      <Route
        path="/auth/cadastrar-senha"
        component={() => <Password action={PassActions.CadastrarSenha} />}
      />
      <Route path="/auth/login" component={Login} />
      <Route
        path="/auth/recuperar-senha"
        component={() => <RecoveryPassword />}
      />
      <Route
        path="/auth/ativar-conta"
        component={() => <ActivateAccount />}
      />
      <Route
        path="/auth/finalizar-cadastro"
        component={() => <FinishRegistration />}
      />
      <Redirect from="/auth" exact={true} to="/auth/login" />
      <Redirect to="/auth/login" />
    </Switch>
  );

  if (isXavierThemeV2Enabled()) {
    return (
      <div className="xv-auth">
        <aside className="xv-auth__brand">
          <Link to="/">
            <XavierWordmark />
          </Link>
          <div className="xv-auth__brand-copy">
            <span className="xv-label-uppercase">Portal do cliente</span>
            <h1>Informação jurídica com clareza e segurança.</h1>
            <p>
              Acompanhe seus processos, documentos e comunicações em um único
              ambiente.
            </p>
          </div>
        </aside>
        <main
          className={`xv-auth__main${
            isFinishRegistration ? " xv-auth__main--registration" : ""
          }`}
        >
          <button
            type="button"
            className="xv-icon-button xv-auth__theme-toggle"
            aria-label={
              mode === "dark"
                ? "Mudar para tema claro"
                : "Mudar para tema escuro"
            }
            onClick={toggleMode}
          >
            {mode === "dark" ? <FiSun /> : <FiMoon />}
          </button>
          <div className="xv-auth__mobile-logo">
            <XavierWordmark compact />
          </div>
          <div
            className={`xv-auth__form-card${
              isFinishRegistration ? " xv-auth__form-card--registration" : ""
            }`}
          >
            {routes}
          </div>
          <small className="xv-auth__legal">
            Advocacia Xavier — acesso exclusivo e protegido
          </small>
        </main>
      </div>
    );
  }

  return (
    <div
      className="kt-grid kt-grid--ver kt-grid--root"
      style={{
        height: "100%",
        background: globalColors.primaryColor1,
        overflow: "hidden",
      }}
    >
      <div
        id="kt_login"
        className=" kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v1"
      >
        <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--desktop kt-grid--ver-desktop kt-grid--hor-tablet-and-mobile">
          <div
            className="kt-grid__item kt-grid__item--order-tablet-and-mobile-2 kt-grid kt-grid--hor kt-login__aside"
          >
            <div
              className="kt-grid__item kt-login__brand"
            >
              <Content
                loading={!logo}
                style={{
                  paddig: "50%",
                }}
              >
                <Link to="/" className="kt-login__logo justify-content-center">
                  <img
                    alt="Logo"
                    src={logo}
                    className="kt-login__brand-logo"
                  />
                </Link>
              </Content>
              <div
                style={{
                  backgroundColor: globalColors.colorWhite,
                  height: "6px",
                }}
              ></div>
              <div
                className="kt-login__brand-name"
                style={{
                  backgroundColor: globalColors.primaryColor5,
                  color: globalColors.colorWhite,
                }}
              >
                ADVOCACIA
              </div>
            </div>
          </div>

          <div
            style={{ padding: 0 }}
            className="kt-grid__item kt-grid__item--fluid kt-grid__item--order-tablet-and-mobile-1  kt-login__wrapper"
          >
            <Switch>
              {/* <Route
                path="/auth/recuperar-senha"
                component={() => (
                  <Password action={PassActions.RecuperarSenha} />
                )}
              /> */}
              <Route
                path="/auth/cadastrar-senha"
                component={() => (
                  <Password action={PassActions.CadastrarSenha} />
                )}
              />

              <Route path="/auth/login" component={Login} />
              <Route
                path="/auth/recuperar-senha"
                component={() => <RecoveryPassword />}
              />
              <Route
                path="/auth/ativar-conta"
                component={() => <ActivateAccount />}
              />
               <Route
                path="/auth/finalizar-cadastro"
                component={() => <FinishRegistration />}
              />
              <Redirect from="/auth" exact={true} to="/auth/login" />
              <Redirect to="/auth/login" />
            </Switch>
          </div>
        </div>
      </div>
    </div>
  );
}
